module.exports = __webpack_public_path__ + "media/images/icons/top_picks-c98b60f55eccb55b66e350a5ac671e29.svg";